const GetDirection = () => {

    document.addEventListener('DOMContentLoaded', function() {
        const getLocationButton = document.getElementById('getLocationButton');
        const popupGetLocation = document.querySelector('.popup-get-location');
        let locationInput = document.getElementById('locationInput');
        
        if (getLocationButton) {
            getLocationButton.addEventListener('click', function() {
                searchLocations();
            });
        }
        if (popupGetLocation) {
            popupGetLocation.addEventListener('click', function() {
                searchLocations();
            });
        }
        
        if(locationInput){
            locationInput.addEventListener('keydown', function(event) {
                if (event.key === 'Enter') {
                    searchLocations();
                }
            });
        }
        

        function searchLocations() {
            const enteredLocation = locationInput.value;
            const location = encodeURIComponent(document.getElementById('mapAddress').value);
            const url = 'https://www.google.com/maps/dir/' + encodeURIComponent(enteredLocation) + '/' + location;
            window.open(url, '_blank');
        }
    });
}

export default GetDirection